import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Message } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastQueueService {
  private messageQueue: Message[] = [];
  private isProcessingQueue = false;

  constructor(private messageService: MessageService) {}

  /**
   * Agrega un mensaje a la cola para mostrar secuencialmente
   */
  addToQueue(message: Message): void {
    this.messageQueue.push(message);

    if (!this.isProcessingQueue) {
      this.processQueue();
    }
  }

  /**
   * Procesa la cola de mensajes mostrando uno a la vez
   */
  private async processQueue(): Promise<void> {
    if (this.messageQueue.length === 0) {
      this.isProcessingQueue = false;
      return;
    }

    this.isProcessingQueue = true;
    const message = this.messageQueue.shift()!;

    // Mostrar el mensaje
    this.messageService.add(message);

    // Esperar el tiempo de vida del mensaje + un pequeño buffer
    const waitTime = (message.life || 5000) + 500; // 500ms buffer

    await this.delay(waitTime);

    // Procesar siguiente mensaje en la cola
    this.processQueue();
  }

  /**
   * Limpia todos los mensajes pendientes en la cola
   */
  clearQueue(): void {
    this.messageQueue = [];
    this.isProcessingQueue = false;
    this.messageService.clear();
  }

  /**
   * Función helper para crear delay
   */
  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  /**
   * Métodos de conveniencia para diferentes tipos de mensajes
   */
  addSuccess(summary: string, detail: string, life: number = 5000): void {
    this.addToQueue({
      key: 'mensajesDeValidacion',
      severity: 'success',
      summary,
      detail,
      life,
    });
  }

  addError(summary: string, detail: string, life: number = 10000): void {
    this.addToQueue({
      key: 'mensajesDeValidacion',
      severity: 'error',
      summary,
      detail,
      life,
    });
  }

  addWarn(summary: string, detail: string, life: number = 5000): void {
    this.addToQueue({
      key: 'mensajesDeValidacion',
      severity: 'warn',
      summary,
      detail,
      life,
    });
  }

  addInfo(summary: string, detail: string, life: number = 5000): void {
    this.addToQueue({
      key: 'mensajesDeValidacion',
      severity: 'info',
      summary,
      detail,
      life,
    });
  }
}
